import MenuList from './MenuList';
import MenuShow from './MenuShow';

export default {
  list: MenuList,
  show: MenuShow,
};
